// Shared `menu.*` i18n keys (used by MainMenuConfig.ts for sidebar entries).
// Section headings and individual item labels are read by the layout system.

export const menuDict: Record<string, [en: string, th: string]> = {
  "menu.dashboard": ["My Cellar", "แดชบอร์ด"],
  "menu.wineManagementSection": ["Managements", "จัดการ"],
  "menu.wineCatalog": ["Wine Lists", "รายการไวน์"],
  "menu.rfidAndBottles": ["Wine Bottles", "รายการขวดไวน์"],
  "menu.rfid": ["RFID Tracking", "RFID Tracking"],
  "menu.categories": ["Bev Categories", "หมวดหมู่เครื่องดื่ม"],
  "menu.wineLocations": ["Cellar Locations", "ตำแหน่งจัดเก็บ"],
  "menu.reports": ["Reports", "รายงาน"],
  "menu.stockOnHand": ["Stock Report", "รายงานสต็อกคงเหลือ"],
  "menu.audit": ["Audit Report", "รายงานตรวจนับ"],
  "menu.activityLogs": ["Activity Logs", "บันทึกกิจกรรม"],
  "menu.receivingReports": ["Receiving Logs", "รายงานการรับเข้า"],
  "menu.companies": ["Companies", "บริษัท"],
  "menu.users": ["User Management", "จัดการผู้ใช้"],
  "menu.userGroups": ["User Groups", "กลุ่มผู้ใช้"],
  "menu.roles": ["Roles & Permissions", "บทบาทและสิทธิ์"],
  "menu.bottleStatuses": ["Bottle Statuses", "สถานะขวด"],
  "menu.systemConfig": ["System Config", "ตั้งค่าระบบ"],
  "menu.settings": ["Settings", "ตั้งค่า"],
  "menu.menuBuilder": ["Digital Menu", "เมนูดิจิทัล"],
};
